var exports = {
  "kL": "xa15a2ab7--07550d--container",
  "LO": "xa15a2ab7--07550d--container-with-mortgage-annotations",
  "Qs": "xa15a2ab7--07550d--content",
  "Hs": "xa15a2ab7--07550d--photo-block",
  "cn": "xa15a2ab7--07550d--photo-label",
  "w7": "xa15a2ab7--07550d--annotation",
  "tX": "xa15a2ab7--07550d--title-container",
  "K2": "xa15a2ab7--07550d--logo-container",
  "YB": "xa15a2ab7--07550d--mortgage-annotations",
};

module.exports = exports;
